module.exports = __webpack_public_path__ + "img/logo-m.45ad26ae.png";